var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('router-view')],1),_c('a-space',{directives:[{name:"show",rawName:"v-show",value:(_vm.beian),expression:"beian"}]},[_c('div',[_vm._v("四川珅鑫科技有限公司")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("蜀ICP备2024094312号-1")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }